import script from "./FeesList.vue?vue&type=script&setup=true&lang=js"
export * from "./FeesList.vue?vue&type=script&setup=true&lang=js"

import "./FeesList.vue?vue&type=style&index=0&id=165ba7c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165ba7c3"]])

export default __exports__